module.exports = __webpack_public_path__ + "assets/images/1DBox.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1DBox.png
// module id = 1288
// module chunks = 1